module.exports = __webpack_public_path__ + "img/paradise_logo.b4591d65.svg";